<template>
    <a-layout-sider
        v-model="collapsed"
        :trigger="null"
        collapsible
        collapsedWidth = 80
        width = 240
        theme="dark"
        :style="{background:'#001529'}"
    >
        <div class="sidebar_top">
            管理后台
        </div>
        <a-menu
            :defaultOpenKeys="openKeys"
            :defaultSelectedKeys="current"
            :openKeys.sync="openKeys"
            mode="inline"
            theme="dark"
            @click="handleClick"
        >
            <a-menu-item key="1">
                <router-link to="/"><a-icon type="dashboard" /><span>站点概况</span></router-link>
            </a-menu-item>
            <a-sub-menu key="2" @titleClick="titleClick">
                <span slot="title"><a-icon type="profile" /><span>主要功能</span></span>
                <a-menu-item key="21">
                    <router-link to="/bogus">借款/报销单</router-link>
                </a-menu-item>
            </a-sub-menu>
            <a-menu-item key="3">
                <router-link to="/ChangePassword"><a-icon type="user" /><span>修改密码</span></router-link>
            </a-menu-item>
        </a-menu>
    </a-layout-sider>
</template>

<script>
export default {
    name: "menu_sidebar",
    data(){
        return {
        };
    },
    computed:{
        collapsed(){
            return this.$store.state.collapsed
        },
        current:{
            get:function() {
                return this.$store.state.sidebar_current
            },
            set:function() {
                return this.$store.state.sidebar_current
            },
        },
        openKeys:{
            get:function() {
                return this.$store.state.sidebar_openKeys
            },
            set:function() {
                return this.$store.state.sidebar_openKeys
            },
        },
    },
    watch: {
        openKeys(val) {
            console.log('openKeys', val);
        },
    },
    methods:{
        handleClick(e) {
                this.current[0] = this.current[0] === e.key ? []: e.key
        },
        titleClick(e) {
            this.openKeys[0] = this.openKeys[0] === e.key ? '': e.key
        },
    }
}
</script>

<style scoped>
    .sidebar_top
    {height:50px;
        line-height:50px;
        text-align:center;
        font-size:24px;
        background:rgb(60, 141, 188);
        border-right:1px solid #FFFFFF;
        padding:0 20px;overflow: hidden;
    }
</style>